import React, { useEffect, useState, useRef } from 'react';
import { connect, useSelector } from 'react-redux';
import moment from 'moment';
import { isEqual } from 'lodash'
import { useLocation } from 'react-router-dom';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { savePDF } from '@progress/kendo-react-pdf';
import { useTranslation } from 'react-i18next';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import Notification from 'rc-notification';
import SmallLoader from '../../../../shared/components/SmallLoader';
import { RTLProps } from '../../../../shared/prop-types/ReducerProps';
import LifeTimeValueTable from './LifeTimeValueTable';
import LifeTimeValueShow from './LifeTimeValueShow';
import { getLifeTimeValueData, handleLoader } from '../../../../redux/actions/LifeTimeValueAction';
import { months } from '../../CompareMonth/helper';
import { setCurrencyFormat, findMonthsBetweenDates } from '../../../../utils/helpers';
import ViewSalesReportModal from '../../SalesCategoryByDay/ViewSalesReportModal';
import { filterShowWise, vendorNameMapping, sortType } from '../../helper';

const LifeTimeValue = ({ dispatch, rtl, vendor }) => {
  const { t } = useTranslation('common');
  const location = useLocation();

  const currentYear = moment().format('YYYY');
  const preYear = moment().subtract(1, 'years').format('YYYY');
  const currentMonth = moment().format('MMM');
  const prevMonth = moment().subtract(6, 'months').format('MMM');

  const { lifeTimeValueData, salesChannelFilterData, isLoading } = useSelector(
    ({ lifeTimeValueReducer, marketPlaceReducer }) =>
    ({
      lifeTimeValueData: lifeTimeValueReducer?.[vendor]?.lifeTimeValueData,
      salesChannelFilterData: marketPlaceReducer.salesChannel,
      isLoading: lifeTimeValueReducer?.[vendor]?.isLoading
    })
  );

  const salesChannelRef = useRef({})

  const [dataToShow, setDataToShow] = useState(lifeTimeValueData?.modal?.data);
  const [showMarketPlaceMessage, setShowMarketPlaceMessage] = useState(false)
  const [isOpen, setIsOpen] = useState(false);
  const [filterData, setFilterData] = useState({});
  const [currentlyShow, setCurrentlyShow] = useState(filterShowWise?.[0])
  const [maxValueObj, setMaxValueObj] = useState({})
  const [month2, setMonth2] = useState({ year: currentYear, month: currentMonth })
  const [month1, setMonth1] = useState({ year: preYear, month: prevMonth });
  const [tempMonth2, setTempMonth2] = useState({ year: currentYear, month: currentMonth });
  const [tempMonth1, setTempMonth1] = useState({ year: preYear, month: prevMonth })


  const yearOptions = [];
  for (let year = 2016; year <= currentYear; year += 1) {
    yearOptions.push({ label: year, value: year })
  }

  const monthOptions = months.map(item => ({ label: item, value: item }));

  const date1 = `${month1?.year}-${month1?.month}`;
  const date2 = `${month2?.year}-${month2?.month}`;

  const filterBasedOnFilter = (item) => {
    const filters = Object.keys(filterData);
    let flag = true
    // eslint-disable-next-line no-restricted-syntax
    for (const i of filters) {
      const filter = filterData[i];
      const filtersArray = filter?.reduce((acc, fil) => [...acc, fil?.value], []) ?? [];
      if (filtersArray?.length && !filtersArray.includes(item[i]?.toLowerCase())) {
        flag = false
      }
    }

    return flag
  }

  const container = React.useRef(null);
  const exportToPDF = () => {
    // console.log('Hello')
    Notification.newInstance({}, (notification) => {
      notification.notice({
        content: 'PDF loading......',
        duration: 10,
        style: {top: 120, fontWeight: "bold"},
        maxCount: 10
      });
    });
    const dvChartV = document.getElementById('dvChartView');
    dvChartV.style.display = "none";    
    const element = container.current || document.body;
    
    savePDF(element, {
      paperSize: "auto",
      Header: "test",
      margin: { left: "1cm", top: "1cm", right: "1cm", bottom: "1cm" },
     // margin: "2cm",
     // forcePageBreak: ".page-break",
    //   landscape: true,
    //  multiPage: true,
      fileName: `Lifetime Value Report ${new Date().getFullYear()}`,
    })
    dvChartV.style.display = "block"; 
  }

  const callApi = () => {
    setShowMarketPlaceMessage(false)
    dispatch(handleLoader(true, vendor));
    dispatch(getLifeTimeValueData(
        {
          fromYear: tempMonth1?.year,
          toYear: tempMonth2?.year,
          fromMonth: moment().month(tempMonth1?.month).format('M'),
          toMonth: moment().month(tempMonth2?.month).format('M'),
          salesChannel: vendor === 'shopify' ? ['shopify.com'] :
                filterData?.salesChannel?.map(item => item.value) || [],
          vendor
        }
    ));
}

  const handleApplyDate = () => {
    const startDate = `${tempMonth1?.year}-${tempMonth1?.month}`;
    const endDate = `${tempMonth2?.year}-${tempMonth2?.month}`

    const monthsBetween = findMonthsBetweenDates(startDate, endDate);
    if (monthsBetween?.length > 0 && monthsBetween?.length <= 120) {
      setMonth1(tempMonth1);
      setMonth2(tempMonth2);
      setMaxValueObj({})
      callApi();
    } else {
      Notification.newInstance({}, (notification) => {
        notification.notice({
          content: 'Please select maximum ten years data'
        });
      });
    }
  }

  const handleYearMonthChange = ({ isFrom, field, value }) => {

    if (isFrom) {
      setTempMonth1({ ...tempMonth1, [field]: value?.value });
    } else {
      setTempMonth2({ ...tempMonth2, [field]: value?.value })
    }
  }

  const getMonths = (start, end) =>
    Array.from({ length: end.diff(start, 'month') + 1 }).map((_, index) =>
      moment(start).add(index, 'month').format('MMM-YYYY'));

  const selectedFromMonth = month1.month;
  const selectedFromYear = month1.year;
  const selectedToMonth = month2.month;
  const selectedToYear = month2.year;

  const selectFromDate = selectedFromMonth + selectedFromYear;
  const selectToDate = selectedToMonth + selectedToYear;

  const selectedMonths = getMonths(moment(selectFromDate, 'MMMYYYY'), moment(selectToDate, 'MMMYYYY'))

  // eslint-disable-next-line react/prop-types
  const RenderYearAndMonth = ({ isFrom }) => (
    <Col sm="12" md="4">
      <Row className="justify-content-space-between">
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Year</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.year, label: tempMonth1?.year }
                  : { value: tempMonth2?.year, label: tempMonth2?.year }}
                options={yearOptions}
                clearable={false}
                placeholder="Select Year"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'year', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'from' : 'to'}
              />
            </div>

          </div>
        </Col>
        <Col md="5" sm="6">
          <div className="form__form-group mb-0">
            <span className="form__form-group-label">Month</span>
            <div className="form__form-group-field">
              <Select
                value={isFrom ? { value: tempMonth1?.month, label: tempMonth1?.month }
                  : { value: tempMonth2?.month, label: tempMonth2?.month }}
                options={monthOptions}
                clearable={false}
                placeholder="Select Month"
                className="select_filter-110"
                onChange={value => handleYearMonthChange({ isFrom, field: 'month', value })}
                classNamePrefix="react-select"
                name={isFrom ? 'fromMonth' : 'toMonth'}
              />
            </div>
          </div>
        </Col>
      </Row>
    </Col>
  );

  const changeFilter = (value) => {
    setCurrentlyShow(value)
  };

  useEffect(() => {
    callApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setDataToShow(lifeTimeValueData?.modal?.data);
  }, [lifeTimeValueData]);

  useEffect(() => {
    const OptChennel = 'salesChannel';
    if (salesChannelFilterData && !isEqual(salesChannelFilterData, salesChannelRef?.current?.salesChannel || [])) {
      setShowMarketPlaceMessage(true)
      salesChannelRef.current = { [OptChennel]: salesChannelFilterData }
      setFilterData({ ...filterData, [OptChennel]: salesChannelFilterData });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [salesChannelFilterData])  

  const dataToShowForDatesSelected = dataToShow?.filter(item => filterBasedOnFilter(item)) || []
  const viewReportButton = () => (
    <div className="view-report">
      <button
        type="button"
        className="view-report btn btn-primary btn-sm"
        onClick={() => setIsOpen(true)}
      >
        View Report
      </button>
    </div>
  )

  const dataToShowForExcel = [];
  const tableHeader = [];

  dataToShowForDatesSelected?.forEach((dataValue, index) => {
     const subData = {}
     subData.monthYear = `${moment().month(dataValue?.month).subtract(1, 'months').format('MMM')}-${dataValue?.year}`
     subData.totalNewCustomers =  dataValue?.totalNewCustomers
     subData.customerAcquisitionCost =  setCurrencyFormat(Number(dataValue?.customerAcquisitionCost).toFixed(0), true)
     subData.repeteadCustomerPercentage =  `${dataValue?.repeteadCustomerPercentage} %`
     subData.firstOrder =  setCurrencyFormat(Number(dataValue?.firstOrder).toFixed(2), true)

     if (index === 0) {
       tableHeader.push({
         Header: 'FIRST ORDER AT',
         accessor: 'monthYear',
         disableGlobalFilter: false,
         width: 150,
         sortType
       })
       tableHeader.push({
        Header: 'NEW CUSTOMERS',
        accessor: 'totalNewCustomers',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
      tableHeader.push({
        Header: '*CAC',
        accessor: 'customerAcquisitionCost',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
      tableHeader.push({
        Header: 'R-%',
        accessor: 'repeteadCustomerPercentage',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
      tableHeader.push({
        Header: 'FIRST ORDER',
        accessor: 'firstOrder',
        disableGlobalFilter: false,
        width: 150,
        sortType
      })
     }
     dataValue?.monthSinceFirstOrderDTOs?.forEach((item) => {
       subData[moment(item?.yearMonth).format('MMM-YYYY')] = 
       `${setCurrencyFormat(Number(item?.avgOrderAmount).toFixed(2), true)} / ${Number(item?.percentage).toFixed(2)} %`
        ;
       if (index === 0) {
         tableHeader.push({
           Header: moment(item?.yearMonth).format('MMM-YYYY'),
           accessor: moment(item?.yearMonth).format('MMM-YYYY'),
           disableGlobalFilter: false,
           width: 120,
           sortType
         })
       }
     });
     dataToShowForExcel.push(subData)
   });
   console.log(tableHeader)
   console.log(dataToShowForExcel)
  return (
    <Container className="dashboard">
      <Row className="category-sales">
        <Col sm="12">
          <Card className="pb-3">
            <CardBody className="min-w-50 p-3">
              <div className="card__title mb-2">
                <h5 className="bold-text card__title-center">{vendorNameMapping[vendor]} Life Time Value</h5>
              </div>
              <Row className="justify-content-space-between align-items-center">            
                <Col sm="12" md="9">
                  <Row className="justify-content-right align-items-center ">
                    <RenderYearAndMonth isFrom />
                    <Col sm='1' className="filter-to-position">~</Col>
                    <RenderYearAndMonth />
                    <Col sm="3" className="p-0 filter-to-position">
                      <button className="btn btn-sm btn-primary
                                             apply-date-button"
                        type="button" onClick={handleApplyDate}>
                        Apply</button>
                        <button className="btn btn-sm btn-primary
                                             apply-date-button"  type="button"
                                             title='Export to pdf' disabled={isLoading}
                                    onClick={exportToPDF}>Export PDF</button>
                    </Col>                   
                  </Row>
                </Col>
                <Col sm="12">
                  <span style={{ color: 'red', alignItems: 'right' }}>
                    {showMarketPlaceMessage ? <small>*Hit Apply to fetch latest data </small> : ''}</span>
                </Col>
              </Row>
            </CardBody>
          </Card>
        </Col>
      </Row>
      <div id="divToPrint" ref={container}>
      <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                    >
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <LifeTimeValueTable
                                dataToShowForDatesSelected={dataToShowForDatesSelected}
                                month={selectedMonths}
                                categorisedBasedOn={currentlyShow?.value}
                                title='Life Time Value'
                                firstColumn={currentlyShow?.label}
                                currentlyShow={currentlyShow}
                              />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            <Card className="pb-3">
                <CardBody className="">
                    <div className="top-location"
                        style={{ minHeight: '400' }}>
                        <div >
                            {isLoading ? <div style={{ minHeight: '200px' }}
                                className="row align-items-center justify-content-center">
                                <SmallLoader loading={isLoading} />
                            </div>
                                : <LifeTimeValueShow
                                dir={rtl.direction}
                                dataToShowForDatesSelected={dataToShowForDatesSelected}
                                height={450}
                                title='Life Time Value'
                                viewReportButton={viewReportButton}
                                monthsBetweenDates={selectedMonths}
                                categorisedBasedOn={currentlyShow?.value}
                                isSalesKey='amount'
                                currentlyShow={currentlyShow}
                              />}
                        </div>
                    </div>
                </CardBody>
            </Card>
            </div>

       <ViewSalesReportModal
        modalData={dataToShowForExcel}
        isOpen={isOpen}
        handleModal={setIsOpen}
        tableHeaderData={tableHeader}
        fileName={`${vendorNameMapping[vendor]} Lifetime Report`}
        title={`${vendorNameMapping[vendor]} Lifetime Report`}
      /> 
    </Container>
  );
};

LifeTimeValue.propTypes = {
  dispatch: PropTypes.func.isRequired,
  rtl: RTLProps.isRequired,
  vendor: PropTypes.number.isRequired
}

export default connect(state => ({
  rtl: state.rtl,
}))(LifeTimeValue);